import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ExpandLess: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      d="M12.002 11.597l-4.67 3.465L6 13.516l6.002-4.454L18 13.516l-1.333 1.545-4.665-3.464z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
